// extracted by mini-css-extract-plugin
export var pillWrapper = "_yd-0";
export var showOverflow = "_yd-1";